import { ApiEndpoint } from "@/app/apiEndpoint";
import axios from "@/app/http/axios";
import { TicketChannel } from "@/interface/TicketChannel.interface";

export default class AdminChannelService {
  constructor() {}

  async getAllChannels() {
    const path = ApiEndpoint.AdminTicketChannel.GET_ALL_MAIN;
    try {
      const response = await axios.get<TicketChannel[]>(`${path}`, {
        headers: { "Content-Type": "application/json" },
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getChannelsWithConditions(filter: any) {
    const path = ApiEndpoint.AdminTicketChannel.SEARCH;
    try {
      const response = await axios.post<TicketChannel[]>(`${path}`, filter);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async createMain(value: any) {
    const path = ApiEndpoint.AdminTicketChannel.CREATE_MAIN;
    try {
      const response = await axios.post(`${path}`, value);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async updateMain(id: number, value: any) {
    const path = ApiEndpoint.AdminTicketChannel.UPDATE_MAIN;
    try {
      const response = await axios.patch(
        `${path.replace("{id}", id.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async updateStatusMain(mainId: number, value: any) {
    const path = ApiEndpoint.AdminTicketChannel.UPDATE_STATUS_MAIN;
    try {
      const response = await axios.patch(
        `${path.replace("{id}", mainId.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async orderMain(value: any[]) {
    const path = ApiEndpoint.AdminTicketChannel.ORDER_MAIN;
    try {
      const response = await axios.put(`${path}`, value);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async createSub(mainId: number, value: any) {
    const path = ApiEndpoint.AdminTicketChannel.CREATE_SUB;
    try {
      const response = await axios.post(
        `${path.replace("{mainId}", mainId.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async updateSub(subId: number, value: any) {
    const path = ApiEndpoint.AdminTicketChannel.UPDATE_SUB;
    try {
      const response = await axios.patch(
        `${path.replace("{id}", subId.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async updateStatusSub(subId: number, value: any) {
    const path = ApiEndpoint.AdminTicketChannel.UPDATE_STATUS_SUB;
    try {
      const response = await axios.patch(
        `${path.replace("{id}", subId.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async orderSub(value: any[]) {
    const path = ApiEndpoint.AdminTicketChannel.ORDER_SUB;
    try {
      const response = await axios.put(`${path}`, value);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async deleteSub(subId: number) {
    const path = ApiEndpoint.AdminTicketChannel.UPDATE_SUB;
    try {
      const response = await axios.delete(
        `${path.replace("{id}", subId.toString())}`
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }
}
